import { FormGroup } from '@angular/forms';
import { SignInForm } from './sign-in-form.interface';

export type SignInFormValue = ReturnType<FormGroup<SignInForm>['getRawValue']>;
